const computeStyleChanges = (nextProps, props) => {

  const {
    titleDisplay,
    titleFontSize,
    titleFontColor,
    titleFontStyle,
    titleFontWeight,
    titleTextAlign,
    titleTextTransform,
    titleTextDecoration,

    //Column title styles
    columnTitleFontSize,
    columnTitleFontColor,
    columnTitleFontStyle,
    columnTitleFontWeight,
    columnTitleTextAlign,
    columnTitleTextTransform,
    columnTitleTextDecoration,
    columnTitleBackgroundColor,
    columnTitlePadding,

    //Field styles
    fontSize,
    fontColor,
    fontStyle,
    fontWeight,
    textAlign,
    textTransform,
    textDecoration,
    textOverflow,
    borderColor,
    borderWidth,
    borderRadius,
    backgroundColor,
    padding,
  } = nextProps;

  if (
    titleFontSize !== props.titleFontSize
    || titleDisplay !== props.titleDisplay
    || titleFontColor !== props.titleFontColor
    || titleFontStyle !== props.titleFontStyle
    || titleFontWeight !== props.titleFontWeight
    || titleTextAlign !== props.titleTextAlign
    || titleTextTransform !== props.titleTextTransform
    || titleTextDecoration !== props.titleTextDecoration
    || columnTitleFontSize !== props.columnTitleFontSize
    || columnTitleFontColor !== props.columnTitleFontColor
    || columnTitleFontStyle !== props.columnTitleFontStyle
    || columnTitleFontWeight !== props.columnTitleFontWeight
    || columnTitleTextAlign !== props.columnTitleTextAlign
    || columnTitleTextTransform !== props.columnTitleTextTransform
    || columnTitleTextDecoration !== props.columnTitleTextDecoration
    || columnTitleBackgroundColor !== props.columnTitleBackgroundColor
    || columnTitlePadding !== props.columnTitlePadding
    || fontSize !== props.fontSize
    || fontColor !== props.fontColor
    || fontStyle !== props.fontStyle
    || fontWeight !== props.fontWeight
    || textAlign !== props.textAlign
    || textTransform !== props.textTransform
    || textDecoration !== props.textDecoration
    || textOverflow !== props.textOverflow
    || borderColor !== props.borderColor
    || borderWidth !== props.borderWidth
    || borderRadius !== props.borderRadius
    || backgroundColor !== props.backgroundColor
    || padding !== props.padding

  ) {
    return true;
  }

};

export default computeStyleChanges;
